var Main = {
  init: function init() {
    $('.down').click(function () {
      $('html,body').animate({ scrollTop: $('.section-problems').offset().top }, 600);
    });
  }
};

Main.init();


function onYouTubeIframeAPIReady() {
  var videoBlocks = document.querySelectorAll(".reviews__item");
  for (var u = 0; u < videoBlocks.length; u++) {
    init(videoBlocks[u]);
  }

  function init(elem) {
    var player = undefined;
    var block = elem.querySelector(".reviews__video").getAttribute("id"); 
     

    var video = elem.querySelector(".reviews__video").getAttribute("data-id");
    player = new YT.Player(block, {
      height: 180,
      videoId: video,
      loop: 0,
      playerVars: {
        "enablejsapi": 1,
        "controls": 0,
        "fs": 0,
        "iv_load_policy": 0,
        "rel": 0,
        "showinfo": 0
      }
    });


    var iframe = elem.querySelector(".reviews__video");
    var layer = elem.querySelector(".reviews__video-layer");
    var close = elem.querySelector(".reviews__video-close");
    setupListener(); 


    function setupListener (){
      layer.addEventListener('click', playFullscreen);
    }

    function playFullscreen (){
      player.playVideo();

      setTimeout(function() {
        iframe.classList.add("player-full-screen");
        close.style.display = "block";
      }, 300);
    }

    close.addEventListener("click", function() {
      event.preventDefault();
      player.stopVideo();
      iframe.classList.remove("player-full-screen");
      close.style.display = "";
    });

  };


  // var promoVideo = document.querySelector(".promo-video");
  // var promoBtn = document.querySelector(".section-main__btn");

  // playPromoVideo();

  // function playPromoVideo() {
  //   if (promoVideo == null) {
  //     return;
  //   } else {
  //     promoBtn.addEventListener("click", function() {
  //       var player = undefined;
  //       var video = promoVideo.getAttribute("data-id");
  //       player = new YT.Player(promoVideo, {
  //         height: 180,
  //         videoId: video,
  //         loop: 0,
  //         playerVars: {
  //           "enablejsapi": 1,
  //           "controls": 0,
  //           "fs": 0,
  //           "iv_load_policy": 0,
  //           "rel": 0,
  //           "showinfo": 0
  //         }
  //       });
  //       // var iframe = elem.querySelector(".reviews__video");
  //       // var layer = elem.querySelector(".reviews__video-layer");
  //       var close = promoVideo.querySelector(".reviews__video-close");
  //       // setupListener(); 
  //       // function setupListener (){
  //       //   layer.addEventListener('click', playFullscreen);
  //       // }
  //       // function playFullscreen (){
  //         player.playVideo();

  //         setTimeout(function() {
  //           promoVideo.classList.add("player-full-screen");
  //           close.style.display = "block";
  //         }, 300);
  //       // }
  //       close.addEventListener("click", function() {
  //         event.preventDefault();
  //         player.stopVideo();
  //         promoVideo.classList.remove("player-full-screen");
  //         close.style.display = "";
  //       });

  //     });
  //   }
  // };
}